import { styled } from "@mui/material/styles";
import React from "react";

import useResponsiveIframe from "./ResponsiveIframe.hook";

const ResponsiveIframe = ({ src, homepage }) => {
  const { isMobile, iframeRef } = useResponsiveIframe();

  return (
    <IframeWrapper homepage={homepage} isMobile={isMobile}>
      <InnerIframe
        ref={iframeRef}
        {...{ src, frameBorder: 0 }}
        data-testid={"looker-iframe"}
      />
    </IframeWrapper>
  );
};

const IframeWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "homepage" && prop !== "isMobile"
})(({ homepage, isMobile }) => ({
  position: "relative",
  height: homepage ? isMobile ? "calc(100vh - 130px)" : "calc(100vh - 250px)" : "calc(100vh - 165px)"
}));

const InnerIframe = styled("iframe")(() => ({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%"
}));

export default ResponsiveIframe;
